module.exports = __webpack_public_path__ + "img/lea-30.7a119517.png";